import React from 'react';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import { Form } from 'antd';
import * as actionTypes from '../../../redux/actions/actionTypes';
import { useSelector, useDispatch } from 'react-redux';
import salvaStep from '../../../redux/actions/mock/salvaStep';

import PanelPreventivo from './PanelPreventivo/PanelPreventivo';
import PanelIntestatario from './PanelIntestatario/PanelIntestatario';
import PanelAnagrafici from './PanelAnagrafici/PanelAnagrafici';
import PanelSituazioneLavorativa from './PanelSituazioneLavorartiva/PanelSituazioneLavorativa';
import Navigation from '../../Navigation/Navigation';

const Riepilogo = () => {

    const dispatch = useDispatch();
    const loadingStep = useSelector(state => state.dataReducer.load.loadingStep);

    
    const datiModello = useSelector(state => state.dataReducer.modello);
    const apiPath = useSelector(state => state.dataReducer.dataApiPath);
    const [form] = Form.useForm();

    function onFinish() {
        // dispatch({type: actionTypes.STEP_AVANTI});
        dispatch({type: actionTypes.LOADING_TRUE});
        dispatch(salvaStep(datiModello.datiPratica, datiModello.id, datiModello.codiceBroker, datiModello.currentStep, apiPath, datiModello.numPratica));
    }

    function backToStep(numeroStep){
        dispatch({type: actionTypes.MODIFICA_STEP, stepDiModifica: numeroStep});
    }

    return (
        <div className={stylesForm.Form}>

            <HeaderStep titolo='Riepilogo richiesta' 
                        sottotitolo ='' />
            <Form form={form} onFinish={onFinish}>
                <PanelPreventivo headerPanel='Preventivo' number='1' tornaAlloStep={(step) => backToStep(step)} />

                <PanelIntestatario headerPanel='Dati intestatario' number='2' tornaAlloStep={(step) => backToStep(step)} />

                <PanelAnagrafici headerPanel='Dati anagrafici' number='3' tornaAlloStep={(step) => backToStep(step)} />

                <PanelSituazioneLavorativa headerPanel='Situazione lavorativa' number='4' tornaAlloStep={(step) => backToStep(step)} />

                <Navigation loadingStep={loadingStep} skip={true} />
            </Form>

        </div>
    )
}

export default Riepilogo;